import { BlockError } from '@/blocks.04-project/block-error/block-error';
import { LazyInit } from '@/blocks.04-project/lazy-init/lazy-init';
import toArray from 'lodash-es/toArray';

/***
 * Класс слайдера для товаров в личном кабинете
 */

class EvaluationSlider {
  constructor(elem) {
		this.BlockError = new BlockError({ blockName: 'EvaluationSlider', destroy: this.destroy });

		if (!elem) return this.BlockError.error('elem отсутствует');
    this.block = elem;
    this.block.EvaluationSlider = this;
    this.block.AsyncEvaluationSlider = new Promise((resolve) => {
      this.promiseResolve = resolve;
    }).then((ins) => ins);

    this.LazyInit = new LazyInit({ ins: this, callback: this.init, addClass: 'evaluation-slider_inited' });
    this.LazyInit.init();
  }

  init = async () => {
    this.navNext = this.block.querySelector('.swiper-button-next');
    if (!this.navNext) return this.BlockError.error('Отсутствует .swiper-button-next');

    this.navPrev = this.block.querySelector('.swiper-button-prev');
    if (!this.navPrev) return this.BlockError.error('Отсутствует .swiper-button-prev');

    const { Swiper, Modules } = await Promise.all([
      import(/* webpackChunkName: "Swiper" */ 'swiper'),
      import(
        /* webpackChunkName: "SwiperModules" */
        /* webpackExports: ['Navigation'] */
        'swiper/modules')
    ]).then((data) => {
      return {
        Swiper: data[0]?.Swiper,
        Modules: toArray(data[1]),
      };
    }).catch((err) => {
      throw new Error(err);
    });

    this.swiper = new Swiper(this.block.querySelector('.swiper'), {
      slidesPerView: 1.1,
      spaceBetween: 10,
      breakpoints: {
        576: { slidesPerView: 1, },
        992: { slidesPerView: 2, }, 1440: { slidesPerView: 3, },
      },
      navigation: {
        nextEl: this.navNext,
        prevEl: this.navPrev,
      },
      on: {
        afterInit: (swiper) => this.block.dispatchEvent(new CustomEvent('iv.swiper.inited', { bubbles: true, detail: swiper })),
      },
      modules: Modules,
    });

    this.promiseResolve(this);
    this.block.AsyncEvaluationSlider = this;
  };

  destroy = () => {
    if (this.swiper) this.swiper.destroy();
    if (this.LazyInit) this.LazyInit.destroy();
    if (this.block) {
      this.block.classList.remove('evaluation-slider_inited');
      delete this.block.EvaluationSlider;
      delete this.block.AsyncEvaluationSlider;
    }
  };

  static init() {
    Array.from(document.querySelectorAll('.evaluation-slider:not(.evaluation-slider_inited)')).forEach((elem) => new EvaluationSlider(elem));
  }
}

document.addEventListener('DOMContentLoaded', EvaluationSlider.init);

// Экспорт;
window.Block.EvaluationSlider = EvaluationSlider;
